(function () {
  "use strict";

  angular
    .module("admin.event_calendars.service", [])
    .factory("EventCalendarsService", EventCalendarsService);

  /** @ngInject */
  function EventCalendarsService($http, $q, API) {
    function list(start, limit) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "channels/drops?start=" + start + "&limit=" + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    return {
      list: list,
    };
  }
})();
